import React from "react";
import address from "../../assets/images/contact/map.svg";
import phone from "../../assets/images/contact/phone.svg";
import mail from "../../assets/images/contact/mail.svg";
import wpp from "../../assets/images/contact/brand-whatsapp.svg";
import hero from "../../assets/images/contact/contact-hero.jpg";

const Contact = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  return (
    <div id="contact" className="contact-container">
      <div className="contact-icons-container">
        <div>
          <div className="address-icon-container">
            <img src={address} alt="adress Icon" />
          </div>
          <p>Dirección</p>
        </div>
        <div>
          <div className="phone-icon-container">
            <img src={phone} alt="phone Icon" />
          </div>
          <p>Telefono</p>
        </div>
        <div>
          <div className="mail-icon-container">
            <img src={mail} alt="mail Icon" />
          </div>
          <p>Email</p>
        </div>
        <div>
          <div className="wpp-icon-container">
            <img src={wpp} alt="whatsapp Icon" />
          </div>
          <p>WhatsApp</p>
        </div>
      </div>
      <div className="form-hero-container">
        <form onSubmit={handleSubmit}>
          <h3>Contactanos</h3>
          <input type="text" placeholder="Nombre" name="name" />
          <input type="text" placeholder="Telefono" name="phone" />
          <input type="mail" placeholder="Email" name="mail" />
          <textarea placeholder="Mensaje" name="message" />
          <button>Enviar</button>
        </form>
        <div>
          <img src={hero} alt="Contact Hero Image" />
        </div>
      </div>
    </div>
  );
};

export default Contact;
